import * as React from 'react';
export var SelectContext = /*#__PURE__*/React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tree-select/es/Context.js
// module id = 504
// module chunks = 0